import { useAppStore } from '../../app/appStore';
import { useAuthStore } from '../../features/auth/authStore';
import { ActivitiesSheet } from './MePage';

// 福利/活动中心：把原 ActivitiesSheet 抽屉升级为一等页面（variant="page"）。
// 5 区（精选 Drum / 每日必做签到 / 我的资产 / 全部活动目录 / 记录）都在 ActivitiesSheet 内。
export function RewardsPage() {
  const token = useAuthStore((state) => state.token);
  const setRoute = useAppStore((state) => state.setRoute);
  const openWalletTicketsFlow = useAppStore((state) => state.openWalletTicketsFlow);
  const setMeSecurityTargetChannel = useAppStore((state) => state.setMeSecurityTargetChannel);

  return (
    <ActivitiesSheet
      token={token || ''}
      variant="page"
      onClose={() => setRoute('lobby')}
      onRoute={(route) => setRoute(route)}
      onVerifyContact={(channel) => {
        // Contact binding lives in Security, per channel — KYC is document
        // verification and was the wrong screen entirely.
        setMeSecurityTargetChannel(channel ?? null);
        setRoute(channel ? 'me.security' : 'me.kyc');
      }}
      onRaffle={(view, resultId) => {
        // Land in the Sorteios venue, where the edition and draw time are
        // visible — never the bare tickets page. A settled draw still
        // deep-links straight to its result as a modal over this page.
        if (view === 'result') openWalletTicketsFlow('result', resultId ?? null);
        else setRoute('sorteios');
      }}
      onInvite={() => setRoute('me.invite')}
    />
  );
}
